import { PatientModel } from './../../../models/consultation/patient.model';
import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { PatientUrl } from '../../../shared/urls/patient.url';
import { ConsultationUrl } from '../../../shared/urls/consultation.url';
import { ConsultationStep } from '../../../models/consultation/consultation.model';

@Injectable()
export class PatientDetailService {
    constructor(public baseService: BaseService) {

    }
    getPatientDetail(id) {
        const url = PatientUrl.GET_PATIENT_ACCOUNT.replace('{id}', id);
        return this.baseService.getData(url);
    }
}


// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/patient-detail/patient-detail.service.ts